<template>
  <div>
    <article>
      <header>
        <h2>Ticket Clicks</h2>
      </header>
      <main>
        <p>
          <label for="filter-date">
            Zeige Einträge ab diesem Zeitpunkt:
          </label>
          <input type="datetime-local" v-model="filterDate"/>
          <p>
            {{ filterDate }}
          </p>
          <button @click="loadRequests">Anwenden</button>
        </p>
        <p>
          Die nachfolgende Liste zeigt, wann der Button "Ticket kaufen" im ausgewählten Zeitraum geklickt wurde.
        </p>
        <div class="chart" v-if="dayBars">
          <div class="canvas">
            <div class="marker" v-for="marker in marks" :style="{ bottom: `${marker.height * 100}%` }">
              <div class="amount">{{ marker.amount }}</div>
            </div>
            <div class="bar" v-for="(bar, index) in dayBars" v-if="bar">
              <div class="fill" :style="{ height: `${bar.height * 100}%` }"></div>
              <div class="tooltip" :class="{ left: index > dayBars.length * 0.5 }">
                <table>
                  <tr v-if="bar.firstDate">
                    <td>Datumsbereich</td>
                    <td>
                      <span style="white-space: nowrap">{{ bar.firstDate.toLocaleString('de-DE') }}</span><br>
                      <span style="white-space: nowrap">{{ bar.lastDate.toLocaleString('de-DE') }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Klicks in diesem Zeitraum</td>
                    <td>{{ bar.sum }}</td>
                  </tr>
                  <tr>
                    <td>Klicks kumuliert</td>
                    <td>{{ bar.acc }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <table>
          <thead>
            <th>Nr.</th>
            <th>Zeitpunkt</th>
          </thead>
          <tbody>
            <tr v-for="(request, index) in requests">
              <td>{{ index + 1 }}</td>
              <td>
                {{
                  (new Date(request.createdAt))
                    .toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'long' })
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </main>
    </article>
  </div>
</template>
<script>

import adminRequest from "@/mixins/admin-request"

const daysBetween = function (a, b) {
  const day = 86400000
  return Math.round(Math.abs((a - b) / day))
}

const TICKET_SALE_START = JSON.parse(process.env.VUE_APP_TICKET_SALE_START)
const ticketSaleStart = new Date(Date.UTC(
  TICKET_SALE_START.year,
  TICKET_SALE_START.month - 1,
  TICKET_SALE_START.day,
  TICKET_SALE_START.hour + TICKET_SALE_START.utcOffset,
));

export default {
  mixins: [adminRequest],
  data() {
    return {
      filterDate: ticketSaleStart,
      requests: null,
    }
  },
  computed: {
    dayAcc() {
      if (!this.requests || this.requests.length < 1) {
        return []
      }

      const first = new Date(this.requests[0].createdAt)
      const last = new Date(this.requests[this.requests.length - 1].createdAt)
      const totalDays = daysBetween(first, last)
      const initial = new Array(totalDays + 1)

      for (let i = 0; i < initial.length; i++) {
        initial[i] = {
          sum: 0,
          firstDate: null,
          lastDate: null,
        }
      }

      return this.requests.reduce((acc, request) => {
        const created = new Date(request.createdAt)
        const index = daysBetween(first, created)
        acc[index].sum += 1
        acc[index].lastDate = created
        acc[index].firstDate = acc[index].firstDate || created

        return acc
      }, initial)
    },
    maxDaySum() {
      return this.dayAcc.reduce((max, day) => {
        if (day.sum && day.sum > max) {
          return day.sum
        }
        return max
      }, 0)
    },
    dayBars() {
      let acc = 0;
      return this.dayAcc.map((day) => {
        acc += day.sum;
        return {
          ...day,
          acc,
          height: day.sum / this.maxDaySum,
        }
      })
    },
    marks() {
      const delta = this.maxDaySum > 300 ? 100 : 10;
      const num = Math.floor(this.maxDaySum / delta)
      const markers = new Array(num).fill(0)

      for (let i = 0; i < num; ++i) {
        markers[i] = {
          height: (i + 1) * delta / this.maxDaySum,
          amount: (i + 1) * delta,
        };
      }

      return markers;
    }
  },
  mounted() {
    this.loadRequests()
  },
  methods: {
    loadRequests() {
      this.adminRequest({
        method: "post",
        data: {
          filter: {
            createdAt: {
              $gte: (new Date(this.filterDate)).toISOString()
            }
          }
        }
      }, 'admin/tickets/request', res => {
        this.requests = res.data
      })
    }
  }
}

</script>
<style scoped lang="scss">
table {
  width: 100%;

  thead {
    th {
      text-align: left;
    }
  }

  th,
  td {
    padding-right: 1em;

    &:last-child {
      padding-right: 0;
    }
  }
}

div.chart {
  height: 400px;
  margin: 1em 0;
  max-width: 100%;
  background: #eee;
  border-radius: 4px;
  padding: 0.5em;

  div.canvas {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
  }

  div.bar {
    width: 0;
    flex: 1 0 0;
    position: relative;
    border: 0;
    margin: 1px;

    div.fill {
      background: grey;
      position: absolute;
      bottom: 0;
      width: 100%;
      border-radius: 3px;
    }

    div.tooltip {
      display: none;
      position: absolute;
      top: 0;
      background: black;
      color: white;
      border-radius: 8px;
      padding: 1em;
      z-index: 100;

      &.left {
        right: 100%;
      }
    }

    &:hover {
      div.fill {
        background: #1976d2;
      }

      div.tooltip {
        display: block;
      }
    }
  }

  div.marker {
    position: absolute;
    background: #fff;
    left: 0;
    right: 0;
    height: 2px;

    div.amount {
      position: absolute;
      right: 0;
      font-size: 80%;
      color: #aaa;
    }
  }
}
</style>
